import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../../UserInfo";
import { Button } from "devextreme-react";
import { criarContribuinteDs, criarLancamentoIptuDs } from "../../../DataSources";
import apiAxios from "../../../api-axios";
import ShowError from "../../../AppServices";

const template = {
  prefeituraId: undefined,
  exercicio: undefined,
  contribuinteId: undefined,
  contribuinteNaoParticipanteId: undefined,
  dataRelancamento: undefined,
  parametroInicial: undefined,
  parametroFinal: undefined,
  relancarImoveis: false,
  naoLancarIgnorados: false,
  naoLancarSemDocumento: false,
  especialBaixio2019: false,
  tipoParametro: "Todos",
  maskOption: null,
  tagsIds: ""
};

export default class LancamentoIptuForm extends React.Component {
  constructor(props) {
    super(props);
    //this.veiculoDs = criarVeiculosDs();
    this.saidaProgramada = false;
    template.prefeituraId = UserInfo.getPrefeitura();
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.state = {};
    this.lancamentoIptuDs = criarLancamentoIptuDs().load().then(response => console.log(response));



    this.tipoLancamento = ["Todos", "Inscrição", "Cartografia"];
    this.onChange = this.onChange.bind(this);
    this.getNomeCodigo = this.getNomeCodigo.bind(this);

    this.contribuinteOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      placeholder: "TODOS",
      dataSource: criarContribuinteDs(),
      valueExpr: "sequencial",
      displayExpr: "nome",
      searchMode: 'contains'
    };

    this.naoContribuinteOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      placeholder: "NENHUM",
      dataSource: criarContribuinteDs(),
      valueExpr: "sequencial",
      displayExpr: "nome",
      searchMode: 'contains'
    };

    this.lancamentoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      placeholder: this.tipoLancamento[0],
      dataSource: this.tipoLancamento,
      defaultValue: this.tipoLancamento[0],
      onValueChanged: (e) => this.onChange(e),
    };
  }

  getNomeCodigo(item) {
    return item ? `${item.nome} ${item.documento}` : '';
  }

  onChange(e) {
    if (e.value === "Todos") {
      this.setState({ tipoDeLancamento: e.value });
    }
    if (e.value === "Inscrição") {
      this.setState({ tipoDeLancamento: e.value, maskOption: "" });
    }
    if (e.value === "Cartografia") {
      this.setState({
        tipoDeLancamento: e.value,
        maskOption: "00.00.000.0000.000",
      });
    }
  }

  componentDidMount() {

    const tagsIds = UserInfo.possuiPerfil("trimap") && UserInfo.getPrefeitura() == 5 ? "3" : "";
    const exercicio = new Date().getFullYear();

    this.setState({ ...template, tagsIds, exercicio });

    console.log(this.state);

  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={2}>
              <GroupItem caption="LANÇAMENTO DE IPTU" colSpan={2} colCount={4}>
                <SimpleItem colSpan={2} dataField={"exercicio"}>
                  <Label text="Ano de Exercício" />
                </SimpleItem>
                <EmptyItem colSpan={2} />

                <SimpleItem
                  dataField={"contribuinteId"}
                  editorType={"dxLookup"}
                  editorOptions={this.contribuinteOptions}
                  colSpan={4}
                >
                  <Label text="Contribuinte" />
                </SimpleItem>

                <SimpleItem
                  dataField={"contribuinteNaoParticipanteId"}
                  editorType={"dxLookup"}
                  editorOptions={this.naoContribuinteOptions}
                  colSpan={4}
                >
                  <Label text="Contribuinte que não participará do lançamento" />
                </SimpleItem>
              </GroupItem>

              <GroupItem caption="Tipo do Lançamento" colSpan={2} colCount={4}>
                <SimpleItem
                  dataField={"tipoParametro"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.lancamentoOptions}
                  colSpan={2}
                >
                  <Label text="Tipo de Lançamento" />
                </SimpleItem>
                <EmptyItem colSpan={2} />
              </GroupItem>
              {this.state.tipoDeLancamento === "Todos" ? null : (
                <GroupItem caption="Parâmetros" colSpan={2} colCount={4}>
                  <SimpleItem
                    editorOptions={{ mask: this.state.maskOption }}
                    colSpan={2}
                    dataField={"parametroInicial"}
                  >
                    <Label text="De" />
                  </SimpleItem>
                  <EmptyItem colSpan={2} />
                  <SimpleItem
                    editorOptions={{ mask: this.state.maskOption }}
                    colSpan={2}
                    dataField={"parametroFinal"}
                  >
                    <Label text="Até" />
                  </SimpleItem>
                  <EmptyItem colSpan={2} />
                </GroupItem>
              )}
              <GroupItem colSpan={2} colCount={5}>
                <SimpleItem
                  dataField={"relancarImoveis"}
                  colSpan={1}
                  editorType={"dxCheckBox"}
                  editorOptions={{
                    onValueChanged: (e) => this.setState({ relancar: e.value }),
                  }}
                >
                  <Label
                    location="right"
                    alignment="left"
                    text="Relançar imóveis que ainda não fizeram pagamento e com emissão até"
                  />
                </SimpleItem>
                <EmptyItem colSpan={1} />
                <SimpleItem
                  colSpan={1}
                  dataField={"dataRelancamento"}
                  editorType={"dxDateBox"}
                  editorOptions={{ readOnly: !this.state.relancar }}
                >
                  <Label
                    location="right"
                    alignment="left"
                    text=""
                    visible={false}
                  />
                </SimpleItem>
                <EmptyItem colSpan={2} />
                <SimpleItem
                  dataField={"naoLancarIgnorados"}
                  colSpan={1}
                  editorType={"dxCheckBox"}
                >
                  <Label
                    location="right"
                    showColon={false}
                    text="Não lançar imóveis não identificados (IGNORADOS)"
                  />
                </SimpleItem>
                <EmptyItem colSpan={4} />
                <SimpleItem
                  dataField={"especialBaixio2019"}
                  colSpan={1}
                  editorType={"dxCheckBox"}
                >
                  <Label
                    location="right"
                    showColon={false}
                    text="Especial Baixio 2019"
                  />
                </SimpleItem>
                <EmptyItem colSpan={4} />
                <SimpleItem
                  dataField={"naoLancarSemDocumento"}
                  colSpan={1}
                  editorType={"dxCheckBox"}
                >
                  <Label
                    location="right"
                    showColon={false}
                    text="Não lançar sem documento"
                  />
                </SimpleItem>
                <EmptyItem colSpan={4} />
                <SimpleItem
                  dataField={"tagsIds"}
                  colSpan={5}
                >
                  <Label
                    text="TAGS IDS"
                  />
                </SimpleItem>

              </GroupItem>
            </Form>
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.ok}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} />
              </div>
            </div>
          </form>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    console.log("dto sendo enviado", entidade);
    apiAxios
      .post("/lancamentos/iptu", entidade)
      .then(response => {
        console.log("response data", response);
        const data = response.data;
        if (!data.sucesso) {
          ShowError([data.msgErro]);
        }
        else {
          this.props.history.push(`/acompanhar_iptu/${data.execucaoId}`);
        }
      })
      .catch(function (error) {
        console.log(error);
        if (error.response && error.response.data && error.response.data.erros) {
          ShowError(error.response.data.erros);
        }
        else {
          ShowError(error.message);
        }
      });
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
